/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * jeeves/v1/api.proto
 * OpenAPI spec version: version not set
 */

/**
 * AutomationStage represents the publication stage of an automation.
This enum is shared across services that manage or execute automations.

 - AUTOMATION_STAGE_UNSPECIFIED: Automation stage is not specified.
 - AUTOMATION_STAGE_DRAFT: Automation is in draft stage and can be modified.
 - AUTOMATION_STAGE_PUBLISHED: Automation is published and immutable, ready for execution.
 */
export type V1AutomationStage =
  (typeof V1AutomationStage)[keyof typeof V1AutomationStage];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const V1AutomationStage = {
  AUTOMATION_STAGE_UNSPECIFIED: 'AUTOMATION_STAGE_UNSPECIFIED',
  AUTOMATION_STAGE_DRAFT: 'AUTOMATION_STAGE_DRAFT',
  AUTOMATION_STAGE_PUBLISHED: 'AUTOMATION_STAGE_PUBLISHED',
} as const;
